'use strict';

var router = require('./router');
var routeView = require('./route-view');

function RouterComponent(channels_map) {
    return router(channels_map).state;
}

function Render(state, opts) {
    return routeView(opts, state);
}

RouterComponent.go = router.atom.set;
RouterComponent.anchor = require('./anchor');
RouterComponent.render = Render;

module.exports = RouterComponent;



//////////////////
// WEBPACK FOOTER
// ./~/mercury-router/index.js
// module id = 140
// module chunks = 0